import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { CategoryData, getExportingOptions } from '../utils/jsonDataProcessing';

interface CoOccurrenceHeatmapProps {
  categoryData: CategoryData;
}

const CoOccurrenceHeatmap: React.FC<CoOccurrenceHeatmapProps> = ({ categoryData }) => {
  // Identify categories that have at least one co-occurrence
  const hasOccurrence = categoryData.categories.map((_, index) => {
    const rowHasValue = categoryData.coOccurrenceMatrix[index].some(value => value > 0);
    const columnHasValue = categoryData.coOccurrenceMatrix.some(row => row[index] > 0);
    return rowHasValue || columnHasValue;
  });

  // Filter categories and co-occurrence matrix
  const filteredCategories = categoryData.categories.filter((_, index) => hasOccurrence[index]);
  const filteredMatrix = categoryData.coOccurrenceMatrix
    .filter((_, rowIndex) => hasOccurrence[rowIndex])
    .map(row => row.filter((_, colIndex) => hasOccurrence[colIndex]));

  const options = {
    chart: {
      type: 'heatmap',
      height: '400px'
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: filteredCategories,
      labels: {
        formatter: function() {
          const text = this.value?.toString() || '';
          return text.length > 15 ? text.substring(0, 15) + '...' : text;
        },
        style: {
          textOverflow: 'ellipsis'
        }
      }
    },
    yAxis: {
      categories: filteredCategories,
      title: null,
      labels: {
        formatter: function() {
          const text = this.value?.toString() || '';
          return text.length > 15 ? text.substring(0, 15) + '...' : text;
        },
        style: {
          textOverflow: 'ellipsis'
        }
      }
    },
    colorAxis: {
      min: 0,
      minColor: '#FFFFFF',
      maxColor: '#0066CC'
    },
    tooltip: {
      formatter: function(this: Highcharts.TooltipFormatterContextObject) {
        return '<b>' + 
          (this.series.xAxis && this.point && 
           filteredCategories[this.point.x as number]) + 
          '</b> co-occurs with <b>' +
          (this.series.yAxis && this.point && 
           filteredCategories[this.point.y as number]) + 
          '</b>: <b>' + this.point.value + '</b> times';
      }
    },
    series: [{
      name: 'Co-occurrence',
      borderWidth: 1,
      data: filteredMatrix.flatMap((row, i) => 
        row.map((value, j) => [j, i, value])
      ),
      dataLabels: {
        enabled: true,
        color: '#000000'
      }
    }],
    ...getExportingOptions('Category Co-occurrence')
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default CoOccurrenceHeatmap;
